import { useMediaQuery, useTheme } from "@mui/material";

export const useQueryMedia = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs"));

  return { isMobile, isMobileSmall };
};
